module.exports = __webpack_public_path__ + "static/img/5d65034d-d421-4492-9e9d-014cb2e3a248.ac4ba0c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oevp/5d65034d-d421-4492-9e9d-014cb2e3a248.jpeg
// module id = 196
// module chunks = 1